import api from './api';

export const getEmployees = (params = {}) => api.get('/employees/', { params });

export const getEmployee = (id) => api.get(`/employees/${id}`);

export const getDepartments = () => api.get('/employees/departments/all');

// Adding a person creates their login - lives under /auth/register on the backend.
export const createEmployee = (data) => api.post('/auth/register', data);

export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data);

export const removeEmployee = (id) => api.delete(`/employees/${id}`);

// Admin-side reset - sets a new password without needing the old one. The
// only recovery path for a forgotten password, since there's no email-based
// "forgot password" flow.
export const resetEmployeePassword = (id, newPassword) =>
  api.put(`/employees/${id}/reset-password`, { new_password: newPassword });

export const updateDepartmentPermissions = (departmentId, fieldPermissions) =>
  api.put(`/employees/departments/${departmentId}/permissions`, { field_permissions: fieldPermissions });

// CEO / System_Admin only (backend-enforced). hodId null clears the head.
export const setDepartmentHead = (departmentId, hodId) =>
  api.put(`/employees/departments/${departmentId}/head`, { hod_id: hodId });

// HR / CEO / HR head only (backend-enforced): everyone currently hidden from
// the People list, and putting one back.
export const getRemovedEmployees = () => api.get('/employees/removed/all');

export const restoreEmployee = (id) => api.put(`/employees/${id}/restore`);
